import { FunctionComponent } from 'react';
 
const GlobalMarginInfoCard: FunctionComponent = () => {
    return <><h3 className="text-primary-std font-medium">Product is using global value</h3>
    <p className="text-secondary-std text-sm leading-tight">
      This value is the global default. You can override the value for this product or create a filter for
      multiple products.
    </p></>;
}
 
export default GlobalMarginInfoCard;
